import { IAttemptListItemResponseForWorkOrder } from "@miplatform/types";

export type CalendarAttemptEvents = Record<
  string,
  IAttemptListItemResponseForWorkOrder
>;

export enum SchedulerViewType {
  Assignment = "assignment",
  Scheduler = "scheduler",
}
